export const PROJECT_OPEN_ITEMS_COUNT = 'PROJECT_OPEN_ITEMS_COUNT';
export const PROJECT_OPEN_ITEMS_CRITICAL_COUNT =
  'PROJECT_OPEN_ITEMS_CRITICAL_COUNT';
export const PROJECT_OPEN_ITEMS_LOAD = 'PROJECT_OPEN_ITEMS_LOAD';



// WEBPACK FOOTER //
// ./src/components/admin/project-open-items/store/action-types.js